<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#3EA56E" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs6 sm6 text-center align-self-center>
        <v-img
          :src="!profilePic ? mediaURL + appUser.image : profilePic"
          height="180px"
          width="180px"
          cover
        >
          <template v-slot:placeholder> <ImageLoader /> </template>
        </v-img>
      </v-flex>
      <v-flex xs12 sm6 align-self-center py-4 py-sm-0>
        <v-layout wrap justify-center>
          <v-flex xs12>
            <v-btn
              small
              block
              dark
              tile
              depressed
              :ripple="false"
              class="text-capitalize"
              color="#3EA56E"
              @click="$refs.uploadProfilePic.click()"
            >
              <span style="font-size: 12px; font-family: opensanssemibold">
                Upload Image
              </span>
              <span>
                <v-icon>mdi-upload</v-icon>
              </span>
            </v-btn>
            <input
              v-show="false"
              accept="image/*"
              ref="uploadProfilePic"
              type="file"
              @change="uploadProfilePic"
            />
          </v-flex>
          <v-flex xs12 pt-4>
            <v-layout wrap justify-center>
              <v-flex xs6 pr-2>
                <v-btn
                  small
                  block
                  tile
                  depressed
                  :ripple="false"
                  class="text-capitalize"
                  color="#EFEFEF"
                  @click="closeDialog"
                >
                  <span style="font-size: 12px; font-family: opensanssemibold">
                    Cancel
                  </span>
                </v-btn>
              </v-flex>
              <v-flex xs6 pl-2>
                <v-btn
                  small
                  block
                  dark
                  tile
                  depressed
                  :ripple="false"
                  class="text-capitalize"
                  color="#3EA56E"
                  @click="uploadPic"
                >
                  <span style="font-size: 12px; font-family: opensanssemibold">
                    Submit
                  </span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,

      profilePic: null,
      profilePicImage: null,
    };
  },
  computed: {
    appUser() {
      return this.$store.state.userData;
    },
  },
  methods: {
    closeDialog() {
      this.profilePic = null;
      this.profilePicImage = null;
      this.$emit("stepper", {
        ref: "close",
        changePicDialog: false,
      });
    },
    uploadProfilePic(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size > 5097152) {
        this.msg = "File Should be less than 2MB";
        this.showSnackBar = true;
        return;
      }
      this.profilePicImage = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.profilePic = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },
    uploadPic() {
      if (!this.profilePicImage) {
        this.msg = "Please select an Image";
        this.showSnackBar = true;
        return;
      }
      var formData = new FormData();
      formData.append("photos", this.profilePicImage);
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/User/UploadImage",
        data: formData,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$store.commit("changePicture", response.data.image);
            this.$emit("stepper", {
              ref: "close",
              changePicDialog: false,
            });
          }
          this.msg = response.data.msg;
          this.showSnackBar = true;
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>